import CurrentUserStore from 'mewe/stores/current-user-store';
import FollowingApi from 'mewe/api/following-api';

export default async function () {
  try {
    const response = await FollowingApi.getFavorites();
    CurrentUserStore.send('handle', { favorites: response });
  } catch (e) {}
}
